// NavigationProvider.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationContext } from './NavigationContext';

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();

  return (
    <NavigationContext.Provider value={{ navigate }}>
      {children}
    </NavigationContext.Provider>
  );
};
